import component from "./ScheduleHome";

export default component;
